<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Mantenimiento de clientes
      </h2>
      <MainCustomers />
    </div>
  </template>
  
  <script>
  import MainCustomers from "@/components/Customers/MainCustomers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "SettingCustomers",
    components: {
        MainCustomers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  